import React from 'react';
import GivePage from './GivePage';

const BODY = `Join the Men of All Saints for our annual Oktoberfest community celebration! Bring the whole family for an afternoon of traditional German food, lively music, and great parish fellowship.

EVENT DETAILS:
• Location: Parish Community Center / Hall
• Highlights: Traditional German Cuisine, Steinholding Contest, Live Music & Dancing

Tickets and volunteer sign-up details will be posted shortly. For questions or to get involved, please contact the parish office or reach out to the Men of All Saints ministry.`;

const Oktoberfest = () => (
  <GivePage
    slug="oktoberfest"
    title="Oktoberfest 2026"
    contentKey="oktoberfest_body"
    defaultBody={BODY}
    contactDescription="Have questions about Oktoberfest or want to volunteer? Reach out to the parish office or the Men of All Saints!"
  />
);

export default Oktoberfest;